import { HttpErrorResponse } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';

export function isAuthHttpError(err: unknown): err is HttpErrorResponse {
  return (
    err instanceof HttpErrorResponse &&
    (err.status === 401 || err.status === 403)
  );
}

/** Prefer API message; use fallback only when the body has no message. */
export function getAuthErrorMessage(
  err: HttpErrorResponse,
  fallback = 'Session expired. Please login again.'
): string {
  const body = err.error;
  if (body && typeof body === 'object' && body.message) {
    return body.message;
  }
  if (typeof body === 'string' && body.trim()) {
    return body;
  }
  return fallback;
}

export function getHttpErrorMessage(
  err: unknown,
  fallback = 'Something went wrong'
): string {
  if (!(err instanceof HttpErrorResponse)) {
    return fallback;
  }
  return getAuthErrorMessage(err, fallback);
}

/** Skip toast for 401/403 — the HTTP interceptor already shows one message. */
export function showHttpErrorToast(
  messageSvc: NzMessageService,
  err: unknown,
  fallback = 'Something went wrong',
  duration = 3500
): void {
  if (isAuthHttpError(err)) {
    return;
  }
  messageSvc.error(getHttpErrorMessage(err, fallback), { nzDuration: duration });
}

let lastSessionExpiryHandledAt = 0;
let sessionExpiryHandling = false;
const SESSION_EXPIRY_COOLDOWN_MS = 2500;

export function shouldHandleSessionExpiry(): boolean {
  const now = Date.now();
  if (
    sessionExpiryHandling ||
    now - lastSessionExpiryHandledAt < SESSION_EXPIRY_COOLDOWN_MS
  ) {
    return false;
  }
  sessionExpiryHandling = true;
  lastSessionExpiryHandledAt = now;
  queueMicrotask(() => {
    sessionExpiryHandling = false;
  });
  return true;
}
